import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (n) => new Intl.NumberFormat("fr-FR").format(Math.round(n || 0));
const STATUS = {
  completed: ["Crédité", "bg-emerald-100 text-emerald-700"],
  pending_verification: ["Paiement signalé", "bg-amber-100 text-amber-800"],
  pending_wave: ["Lien ouvert", "bg-slate-100 text-slate-600"],
  rejected: ["Refusé", "bg-rose-100 text-rose-700"],
};

export default function WaveTopupsPanel() {
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    try {
      setData((await axios.get(`${API}/credits/admin/wave-topups`)).data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Chargement impossible");
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const act = async (url, ok) => {
    try {
      await axios.post(url);
      toast.success(ok);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Action impossible");
    }
  };

  return (
    <Card data-testid="admin-wave-topups-panel">
      <CardHeader className="flex flex-row items-center justify-between flex-wrap gap-3">
        <CardTitle>Recharges Wave</CardTitle>
        <Button variant="outline" size="sm" onClick={load} data-testid="admin-wave-refresh"><RefreshCw className="w-4 h-4 mr-1" />Actualiser</Button>
      </CardHeader>
      <CardContent>
        {data && (
          <div className="flex flex-wrap gap-4 mb-4 text-sm" data-testid="admin-wave-totals">
            <span>Crédité : <b>{fmt(data.total_completed)} FCFA</b> ({data.count_completed})</span>
            <span className="text-amber-700">À vérifier : <b>{data.count_pending}</b></span>
            <span className="text-slate-500">Mode : {data.auto_mode ? "automatique (API Wave)" : "lien Wave + validation admin"}</span>
          </div>
        )}
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase text-slate-500"><th className="pb-2">Date</th><th className="pb-2">Utilisateur</th><th className="pb-2">Portefeuille</th><th className="pb-2">Montant</th><th className="pb-2">Statut</th><th className="pb-2" /></tr>
            </thead>
            <tbody>
              {(data?.topups || []).map((t) => {
                const [label, cls] = STATUS[t.status] || [t.status, "bg-slate-100 text-slate-600"];
                return (
                  <tr key={t.id} className="border-t border-slate-100" data-testid={`admin-wave-row-${t.id}`}>
                    <td className="py-2 pr-3 text-xs">{new Date(t.created_at).toLocaleString("fr-FR")}</td>
                    <td className="py-2 pr-3"><p className="font-semibold">{t.user_name || "—"}</p><p className="text-xs text-slate-500">{t.payment_phone || t.user_phone} · {t.user_role}</p></td>
                    <td className="py-2 pr-3 text-xs">{t.wallet}</td>
                    <td className="py-2 pr-3 font-bold">{fmt(t.amount)} F</td>
                    <td className="py-2 pr-3"><span className={`text-xs font-bold px-2 py-1 rounded-full ${cls}`}>{label}</span></td>
                    <td className="py-2">
                      {t.status.startsWith("pending") && (
                        <div className="flex gap-2">
                          <Button size="sm" onClick={() => act(`${API}/credits/confirm/${t.id}`, "Portefeuille crédité · WhatsApp envoyé")} data-testid={`admin-wave-confirm-${t.id}`}>Créditer</Button>
                          <Button size="sm" variant="outline" onClick={() => act(`${API}/credits/admin/wave-topups/${t.id}/reject`, "Recharge refusée")} data-testid={`admin-wave-reject-${t.id}`}>Refuser</Button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
